export default __webpack_public_path__ + "static/media/Food_01.0feb9336.png";